import { render, staticRenderFns } from "./discountCodeAdd.vue?vue&type=template&id=0923461c&scoped=true&"
import script from "./discountCodeAdd.vue?vue&type=script&lang=js&"
export * from "./discountCodeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923461c",
  null
  
)

export default component.exports